import { ShortCode } from '@highereducation/wordpress';
import { Icon, LucideIconName } from '@highereducation/hen-ui';

interface IconShortcodeProps {
  icon: LucideIconName;
  size?: 'full' | 'sm' | 'md' | 'lg' | 'xl';
  color?: 'default' | 'white' | 'primary' | 'secondary' | 'black' | 'neutral';
  'aria-label'?: string;
  'aria-hidden'?: string;
  [key: string]: any;
}

export const IconShortcode: ShortCode<IconShortcodeProps> = {
  component: ({
    icon,
    size = 'md',
    color = 'default',
    'aria-label': ariaLabel,
    'aria-hidden': ariaHidden,
  }) => {
    if (!icon) {
      return null;
    }

    const isHidden = ariaHidden === 'true' || ariaHidden === '';

    return (
      <Icon
        icon={icon}
        size={size}
        color={color}
        aria-label={ariaLabel}
        aria-hidden={isHidden}
      />
    );
  },
};
